import { Author } from "./author";
import {
  asBoolean,
  asNumber,
  asString,
  isObject,
  parseList,
} from "./model-utils";

export class ProductSubCategory {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.subCategoryId = asString(json.subCategoryId);
    this.name = asString(json.name);
    this.imageUrl = asString(json.imageUrl);
    this.status = asString(json.status);
  }

  get isActive() {
    return this.status?.toUpperCase() === "ACTIVE";
  }

  static fromJson(json: any) {
    return isObject(json) ? new ProductSubCategory(json) : json;
  }
}

export class ProductCategory {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.onlineStore = asBoolean(json.onlineStore);
    this.imageUrl = asString(json.imageUrl);
    this.systemRemove = asBoolean(json.systemRemove);
    this.archive = asBoolean(json.archive);
    this.productCategoryId = asString(json.productCategoryId);
    this.name = asString(json.name);
    this.profileId = asString(json.profileId);
    this.profileType = asString(json.profileType);
    this.profileIdentifier = asString(json.profileIdentifier);
    this.country = asString(json.country);
    this.countryCode = asString(json.countryCode);
    this.status = asString(json.status);
    this.description = asString(json.description);
    this.vatExclude = asBoolean(json.vatExclude);
    this.author = Author.fromJson(json.author);
    this.storefrontMarkUpPercentage = asNumber(
      json.storefrontMarkUpPercentage,
    );
    this.sellingPercentageMarkUp = asNumber(json.sellingPercentageMarkUp);
    this.logisticsScopedProducts = asBoolean(json.logisticsScopedProducts);
    this.subCategories = parseList(json.subCategories, ProductSubCategory.fromJson);
  }

  get isInactive() {
    return this.status?.toLowerCase() === "inactive" || this.isDeactivated;
  }

  get isActive() {
    return this.status?.toLowerCase() === "active";
  }

  get isDeactivated() {
    return this.status?.toUpperCase() === "DEACTIVATED";
  }

  get sellingPercentageMarkUpPresent() {
    return (this.sellingPercentageMarkUp || 0) > 0;
  }

  static fromJson(json: any) {
    return isObject(json) ? new ProductCategory(json) : json;
  }
}
